/**
 * 项目配置
 */
export default {
    // 默认语言，可选 zh(简体中文)、en(英语)
    lang: 'zh',

    // 货币符号
    coin: '￥',

    local: '中国',

    // 是否开启动态路由
    isDynamicRoute: true

}